import Home01 from './Home01';
import Home02 from './Home02';
import Home03 from './Home03';
import Home04 from './Home04';
import Descargas from './Descargas'; // o la ruta correcta

const routes = [
    { path: "/", component: <Home01 />},
    { path: "home02", component: <Home02 />},
    { path: "home03", component: <Home03 />},
    { path: "es", component: <Home04 />},
    { path: "descargas/ejemplo-M3x25", component: <Descargas />}, 
]

export default routes;